// @flow
import path from 'ramda/es/path';

import shopApiRequest from 'app/actions/shopApi';
import action from 'app/common/lib/action';


export const SHOP_ORDER_CANCEL_REQUEST = 'SHOP_ORDER_CANCEL_REQUEST';
export const SHOP_ORDER_CANCEL_SUCCESS = 'SHOP_ORDER_CANCEL_SUCCESS';
export const SHOP_ORDER_CANCEL_FAILURE = 'SHOP_ORDER_CANCEL_FAILURE';


/**
 * Запрос отмены заказа
 */
export const orderCancel = (id: string) => async (dispatch: Function) => {
  dispatch(action(SHOP_ORDER_CANCEL_REQUEST));
  try {
    const res = await shopApiRequest(`orders/${id}/cancel`, 'post');
    const data = path(['data', 'order'], res) || {};
    dispatch(action(SHOP_ORDER_CANCEL_SUCCESS, { data }));
    return data;
  } catch (error) {
    dispatch(action(SHOP_ORDER_CANCEL_FAILURE, {
      err: 'Не удалось отменить заказ',
      error,
    }));
    return null;
  }
};
